import React from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

const Error = () => {
  AOS.init({ duration: 1000 });

  return (
    
    <div className="container-fluid pt-5 mt-5" style={{ backgroundImage: 'url(assets/img/landing/corporate/formatu.jpg', backgroundSize: 'cover', backgroundPosition: 'center', height: '100vh' }}>
      <div className="row justify-content-center">
        <div className="col-12 text-center">
            <br/>
            <p></p>
          <h1 className="display-1 text-info m-4" data-aos="fade-up">
           Ошибка 404
          </h1>
          <h2 className="display-4 text-light m-4" data-aos="fade-up" data-aos-delay="200">
            Страница не найдена | Page not found
          </h2>
          <br/>
          <p></p>
          {/* <p className="lead text-light" data-aos="fade-up" data-aos-delay="400">
            The page you are looking for might have been removed, had its name
            changed or is temporarily unavailable.
          </p> */}
            <br/>
          <p></p>
            <br/>
          <p></p>
            <br/>
          <p></p>
            <br/>
          <p></p>
            <br/>
          <p></p>
            <br/>
          <p></p>
          <br/>
          <p></p>
          <Link to="/" className="btn btn-info m-4" data-aos="fade-up" data-aos-delay="600">
            Back to home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Error;

